import axiosInstance from '../config';

/**
 * Requests a launch URL from the backend for SABA platform.
 * @param {string} [gameId] - Optional sub-game ID
 * @returns {Promise<string|null>} - The launch URL, or null if session expired / invalid
 */
export const launchSaba = async (gameId) => {
  const params = gameId ? { gameId } : {};
  const res = await axiosInstance.get('restricted/saba/launch', { params });
  let data = res && res.data;

  // If response body is a JSON string, parse it
  if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      if (parsed && typeof parsed === 'object') {
        data = parsed;
      }
    } catch (e) {
      // Not JSON, continue treating as plain text
    }
  }

  // If response is an object with { status: true, url: '...' }
  if (data && typeof data === 'object') {
    if (data.url) return data.url;
    if (data.data && data.data.url) return data.data.url;
  }

  // If response is a direct URL string
  if (typeof data === 'string' && data !== 'null' && data.startsWith('http')) {
    return data;
  }

  return null;
};
